(function () {
    "use strict";

    try {
        // 1. URL ảnh Neck Warmer mốc 2
        var CUSTOM_TIER_2_IMAGE_URL = window.CUSTOM_TIER_2_IMAGE_URL || 'https://cdn.shopify.com/s/files/.../neck-warmer.png';

        // 2. Inject CSS viền đen nền trắng an toàn
        try {
            var style = document.createElement('style');
            style.setAttribute('data-salepify-custom', 'progress-bar-tier2');
            style.textContent = `
                .tl__cart-goal__container__drawer[data-sew-skin="editorial"] .pcirc,
                .tl__cart-goal__container__drawer[data-sew-skin="editorial"] .pnode.is-reached .pcirc {
                    background: #ffffff !important;
                }
                .tl__cart-goal__container__drawer[data-sew-skin="editorial"] .pnode.is-reached .pcirc {
                    border-color: var(--tl__cart-goal__filled-bar-color, #000000) !important;
                }
                .tl__cart-goal__goal-check-point__drawer.is-reached {
                    background-color: #ffffff !important;
                    border-color: var(--tl__cart-goal__filled-bar-color, #000000) !important;
                }
            `;
            (document.head || document.documentElement).appendChild(style);
        } catch (cssErr) {
            console.warn('[Salepify Custom] CSS warning:', cssErr);
        }

        // Ngăn theme Cart Drawer chặn sự kiện vuốt/cuộn của popup quà tặng
        (function() {
            ['touchmove', 'wheel'].forEach(function(evt) {
                window.addEventListener(evt, function(e) {
                    if (e.target.closest && e.target.closest('dialog.tl__cart-goal__gift-modal')) {
                        e.stopImmediatePropagation();
                    }
                }, { capture: true, passive: false });
            });
        })();


        // 3. Hàm chuẩn hóa chỉ lấy tên variant (cắt bỏ phần trước dấu ' - ')
        function formatToVariantOnly(fullName) {
            if (!fullName || typeof fullName !== 'string') return fullName;
            var parts = fullName.split(' - ');
            if (parts.length > 1) {
                return parts.slice(1).join(' - ').trim(); // Lấy "Misty Blue"
            }
            return fullName;
        }

        // Quét và cắt tên trên DOM popup
        function cleanModalGiftTitles() {
            try {
                var titleElements = document.querySelectorAll('.tl__cart-goal__product-image-info > p');
                titleElements.forEach(function (el) {
                    if (!el || el.__cleanedTitle) return;
                    var currentText = el.textContent || '';
                    if (currentText.indexOf(' - ') !== -1) {
                        el.textContent = formatToVariantOnly(currentText);
                        el.__cleanedTitle = true;
                    }
                });
            } catch (e) {}
        }

        // Lắng nghe click mở modal popup để quét DOM ngay
        document.addEventListener('click', function (e) {
            if (e.target && e.target.closest && (e.target.closest('.tl__cart-goal__gift-noti') || e.target.closest('.tl__cart-goal__gift-modal'))) {
                setTimeout(cleanModalGiftTitles, 50);
                setTimeout(cleanModalGiftTitles, 200);
            }
        }, true);

        // 4. Chờ app và hook vào tlCartGoalEmbed
        var MAX_RETRIES = 50;
        var attempts = 0;

        var checkInterval = setInterval(function () {
            try {
                attempts++;
                var embed = window.tlCartGoalEmbed;

                if (!embed || typeof embed.getMilestoneIcon !== 'function') {
                    if (attempts >= MAX_RETRIES) clearInterval(checkInterval);
                    return;
                }

                clearInterval(checkInterval);

                if (embed.__customScriptPatched) return;
                embed.__customScriptPatched = true;

                // --- Hook 1: Đổi ảnh mốc 2 ---
                var originalGetMilestoneIcon = embed.getMilestoneIcon.bind(embed);
                embed.getMilestoneIcon = function (milestone) {
                    try {
                        var iconData = originalGetMilestoneIcon(milestone);

                        var isTier2 = false;
                        if (milestone && milestone.title && milestone.title.toLowerCase().indexOf('neck warmer') !== -1) {
                            isTier2 = true;
                        } else if (embed.milestones && embed.milestones.length > 1 && embed.milestones[1].cart_value === milestone.cart_value) {
                            isTier2 = true;
                        }

                        if (isTier2 && CUSTOM_TIER_2_IMAGE_URL) {
                            return {
                                isCustom: true,
                                isCustomImage: true,
                                imgSrc: CUSTOM_TIER_2_IMAGE_URL
                            };
                        }

                        return iconData;
                    } catch (err) {
                        return originalGetMilestoneIcon(milestone);
                    }
                };

                // --- Hook 2: Rút gọn tên variant trong Modal render ---
                if (typeof embed.renderFreeGiftRewardModal === 'function') {
                    var originalRenderModal = embed.renderFreeGiftRewardModal.bind(embed);
                    embed.renderFreeGiftRewardModal = function (cartGoalIndex, giftMilestoneIndex, giftVariants) {
                        try {
                            if (Array.isArray(giftVariants)) {
                                giftVariants.forEach(function (v) {
                                    if (v && v.name) {
                                        v.name = formatToVariantOnly(v.name);
                                    }
                                });
                            }
                        } catch (errModal) {}

                        var result = originalRenderModal(cartGoalIndex, giftMilestoneIndex, giftVariants);
                        cleanModalGiftTitles();
                        return result;
                    };
                }

                // Render lại giao diện ban đầu
                try {
                    if (typeof embed.updateProgressCartGoal === 'function') {
                        embed.updateProgressCartGoal();
                    }
                } catch (e) {}

            } catch (intervalErr) {
                clearInterval(checkInterval);
            }
        }, 150);

    } catch (globalErr) {
        console.warn('[Salepify Custom] Error:', globalErr);
    }
})();

// custom free gift sau discounted
// <!-- Salepify Free Gift: tính điều kiện theo giá sau discount + ô nhập mã giảm giá ở cart drawer / cart page -->
(function () {
    if (window.__tlFreeGiftDiscountedPatched) return;
    window.__tlFreeGiftDiscountedPatched = true;

    var config = Object.assign({
        // true: also subtract order-level discounts (allocated to each line by its share of the subtotal)
        includeOrderDiscount: false,
        // Ratio for items being added that are not in the cart yet and have no known discount.
        // 1 = use original price until the cart is refreshed.
        unknownItemFactor: 1,
        // true: refresh the cart drawer / cart page without reloading the page (themes the app does not support)
        preventReload: true,
        debug: false
    }, window.tlFreeGiftDiscountedConfig || {});

    var LOG_PREFIX = '[FreeGift discounted]';
    // Marks a former gift that is now sold at its original price (hidden property: starts with "_")
    var REVERTED_PROPERTY = '_salepify-reverted-gift';

    var factorByKey = new Map();      // line item key -> discounted / original
    var factorByVariant = new Map();  // variant id -> discounted / original
    var revertedLines = new Map();    // line item key -> { key, id, quantity, ruleId }
    var pendingReverts = [];          // gifts removed in the current check that must be re-added at original price
    var needRerender = false;

    function log() {
        if (config.debug) console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments)));
    }

    // Discounts created by Free Gift itself must not lower the parent price
    function isAppDiscount(app, title) {
        if (!title || !app.codeMapRuleId) return false;
        var code = app.utils && app.utils.decodeHtml ? app.utils.decodeHtml(title) : title;
        return app.codeMapRuleId.has(code);
    }

    function readCart(app, cart) {
        factorByKey.clear();
        factorByVariant.clear();
        revertedLines.clear();
        if (!cart || !cart.items) return;

        var orderDiscount = 0;
        if (config.includeOrderDiscount) {
            (cart.cart_level_discount_applications || []).forEach(function (discount) {
                if (!isAppDiscount(app, discount.title)) orderDiscount += discount.total_allocated_amount || 0;
            });
        }
        var subtotal = cart.items_subtotal_price || 0;

        cart.items.forEach(function (item) {
            var revertedRuleId = item.properties && item.properties[REVERTED_PROPERTY];
            if (revertedRuleId) {
                revertedLines.set(item.key, { key: item.key, id: String(item.id), quantity: item.quantity, ruleId: String(revertedRuleId) });
            }

            var original = item.original_line_price;
            if (!original) return;

            var discounted = original;
            (item.line_level_discount_allocations || []).forEach(function (allocation) {
                var title = allocation.discount_application && allocation.discount_application.title;
                if (!isAppDiscount(app, title)) discounted -= allocation.amount || 0;
            });

            if (orderDiscount && subtotal) {
                discounted -= orderDiscount * (item.final_line_price / subtotal);
            }

            var factor = Math.min(1, Math.max(0, discounted) / original);
            factorByKey.set(item.key, factor);
            factorByVariant.set(String(item.id), factor);
        });

        log('factors', Object.fromEntries(factorByKey), 'reverted', Array.from(revertedLines.values()));
    }

    function getFactor(key, itemData) {
        if (factorByKey.has(key)) return factorByKey.get(key);
        if (itemData && factorByVariant.has(String(itemData.id))) return factorByVariant.get(String(itemData.id));
        return config.unknownItemFactor;
    }

    // Same as the app's getCustomerBuy, but each line's price is the discounted price.
    // Reverted gifts are not counted, otherwise paying for the old gift could re-qualify the offer.
    async function collectParents(app, rule, items) {
        var checkApplyTo = app.makeApplyToChecker(rule);
        var parentInCart = [];
        var totalProductApplied = 0;
        var numberProductApplied = 0;

        for (var i = 0; i < items.length; i++) {
            var key = items[i][0];
            var itemData = items[i][1];
            if (revertedLines.has(key)) continue;

            if (await checkApplyTo(itemData) && app.checkPurchaseType(itemData, rule.purchase_type)) {
                var discountedPrice = itemData.price * getFactor(key, itemData);
                numberProductApplied += itemData.quantity;
                totalProductApplied += discountedPrice * itemData.quantity;
                // `price` is also used by the "cheapest option" logic, so it gets the discounted value too
                parentInCart.push(Object.assign({ key: key }, itemData, {
                    price: discountedPrice,
                    original_price: itemData.price
                }));
            }
        }

        return { parentInCart: parentInCart, totalProductApplied: totalProductApplied, numberProductApplied: numberProductApplied };
    }

    // Offers whose not-eligible gifts must stay in the cart at original price
    function shouldRevertGifts(app, rule) {
        var constants = app.constants || {};
        var MODULE = constants.MODULE || {};
        var GIFT_TYPE = constants.GIFT_TYPE || {};
        var giftsInTempCart = (app.ruleIdMapGiftsInTempCart && app.ruleIdMapGiftsInTempCart.get(rule.id)) || [];

        return !rule.auto_remove_gift
            && rule.module !== MODULE.BOGO
            && rule.gift_type !== GIFT_TYPE.SAME_BUY
            && !giftsInTempCart.length
            && !(app.itemsInTempCart && app.itemsInTempCart.size);
    }

    function getGiftRuleId(app, properties) {
        if (!properties) return null;
        var constants = app.constants || {};
        return properties[constants.EMBED_PROPERTY] || properties[constants.POPUP_PROPERTY] || null;
    }

    function patchFreeGift(app, isLateLoad) {
        var canRevert = ['checkAllRule', 'getGiftsToRemove', 'handleRemoveGifts', 'handleAddGifts']
            .every(function (name) { return typeof app[name] === 'function'; });

        // 1. Read discount info every time the app reads the cart
        var originalCartGet = app.ajaxApi.cartGet;
        app.ajaxApi.cartGet = async function () {
            var cart = await originalCartGet.apply(this, arguments);
            try {
                readCart(app, cart);
                // Keep the discount box in sync with the latest cart
                lastCart = cart;
                renderAppliedCodes();
            } catch (error) {
                console.warn(LOG_PREFIX, error);
            }
            return cart;
        };

        // 2. Conditions use discounted prices
        app.getCustomerBuy = function (rule) {
            return collectParents(app, rule, app.getItems(rule));
        };

        if (canRevert) patchRevertGifts(app);
        else console.warn(LOG_PREFIX, 'Keeping gifts at original price is not supported by this Free Gift version');

        patchRerender(app);
        patchRefreshCart(app);

        log('Free Gift patched');
        // App already checked the cart with original prices: check again with the new calculation.
        // When the app is still initializing, its own first check already uses the patched methods.
        if (isLateLoad && app.isReady) app.updateCartData();
    }

    function patchRevertGifts(app) {
        // 3. Each full check starts with no pending reverts
        var originalCheckAllRule = app.checkAllRule;
        app.checkAllRule = function () {
            pendingReverts = [];
            return originalCheckAllRule.apply(this, arguments);
        };

        // 4. "Auto remove gift" OFF: pick the not-eligible gifts the same way auto remove does,
        //    remove them, and remember to add them back as normal (full price) lines
        var originalGetGiftsToRemove = app.getGiftsToRemove;
        app.getGiftsToRemove = function (rule, canClaimCount, claimedCount) {
            if (!shouldRevertGifts(app, rule)) return originalGetGiftsToRemove(rule, canClaimCount, claimedCount);

            var updates = originalGetGiftsToRemove(Object.assign({}, rule, { auto_remove_gift: true }), canClaimCount, claimedCount);
            var giftsInCart = app.ruleIdMapGifts.get(rule.id) || [];

            Object.keys(updates).forEach(function (key) {
                var gift = giftsInCart.find(function (item) { return item.key === key; });
                if (!gift) return;
                var revertQty = gift.quantity - updates[key];
                if (revertQty > 0) pendingReverts.push({ id: gift.id, quantity: revertQty, ruleId: rule.id });
            });

            log('revert gifts', rule.id, pendingReverts);
            return updates;
        };

        var originalHandleRemoveGifts = app.handleRemoveGifts;
        app.handleRemoveGifts = async function (updates) {
            var reverts = pendingReverts;
            pendingReverts = [];

            var isRemoved = await originalHandleRemoveGifts.call(this, updates);
            if (isRemoved) needRerender = true;

            if (isRemoved && reverts.length) {
                try {
                    await app.ajaxApi.cartAdd(reverts.map(function (revert) {
                        var properties = {};
                        properties[REVERTED_PROPERTY] = String(revert.ruleId);
                        return { id: Number(revert.id), quantity: revert.quantity, properties: properties };
                    }));
                } catch (error) {
                    console.warn(LOG_PREFIX, 'Error when re-adding gifts at original price', error);
                }
            }
            return isRemoved;
        };

        // 5. Offer eligible again: remove the full-price lines before the app adds the gifts back
        var originalHandleAddGifts = app.handleAddGifts;
        app.handleAddGifts = async function (items) {
            var updates = {};
            (items || []).forEach(function (item) {
                var ruleId = getGiftRuleId(app, item.properties);
                if (!ruleId) return;

                var needQty = item.quantity;
                revertedLines.forEach(function (line) {
                    if (needQty <= 0 || line.ruleId !== String(ruleId) || line.id !== String(item.id)) return;
                    var currentQty = updates[line.key] !== undefined ? updates[line.key] : line.quantity;
                    var takeQty = Math.min(currentQty, needQty);
                    updates[line.key] = currentQty - takeQty;
                    needQty -= takeQty;
                });
            });

            if (Object.keys(updates).length) {
                try {
                    await app.ajaxApi.cartUpdate({ updates: updates });
                    log('restore gifts', updates);
                } catch (error) {
                    console.warn(LOG_PREFIX, 'Error when restoring gifts', error);
                }
            }
            return originalHandleAddGifts.apply(this, arguments);
        };
    }

    function patchRerender(app) {
        // 6. Re-render the Gift in cart widget after gifts were removed or reverted.
        //    The check is tracked so the cart is only refreshed once it is done.
        var originalUpdateCartData = app.updateCartData;
        app.updateCartData = function () {
            var self = this;
            var args = arguments;
            return trackBusy((async function () {
                var result = await originalUpdateCartData.apply(self, args);
                if (needRerender) {
                    needRerender = false;
                    try {
                        if (window.tlGiftInCartWidget && window.tlGiftInCartWidget.trackingCartDrawer) window.tlGiftInCartWidget.trackingCartDrawer();
                    } catch (error) {
                        console.warn(LOG_PREFIX, error);
                    }
                }
                return result;
            })());
        };
    }

    // 7. Free Gift changed the cart: refresh it once, after the progress bar has checked its milestones too
    function patchRefreshCart(app) {
        if (config.preventReload === false || typeof app.refreshCartContent !== 'function') return;

        app.refreshCartContent = function () {
            requestCartRefresh({ checkCartGoal: true });
            return Promise.resolve();
        };
    }

    // Today Offer widget has its own (display only) total calculation
    function patchTodayOffer() {
        var app = window.tlFreeGiftOffer;
        var widget = window.SalepifyTodayOffer && window.SalepifyTodayOffer.widget;
        if (!app || !widget || widget.__tlDiscountedPatched || typeof widget.getDisplayParentInCart !== 'function') return;
        widget.__tlDiscountedPatched = true;

        widget.getDisplayParentInCart = function (rule) {
            if (!app.makeApplyToChecker) return Promise.resolve({ parentInCart: [], totalProductApplied: 0, numberProductApplied: 0 });
            return collectParents(app, rule, Array.from(app.itemsInCart || []));
        };
        log('Today Offer patched');
    }

    // ---- Re-check the cart when a discount code is applied / removed (no reload) ----
    // The app only re-checks after add/change/update requests that change line items.
    // Requests like /cart/update.js { discount: "CODE" } are ignored by the app.
    var recheckTimer = null;

    function scheduleRecheck() {
        clearTimeout(recheckTimer);
        recheckTimer = setTimeout(function () {
            var app = window.tlFreeGiftOffer;
            if (app && typeof app.updateCartData === 'function') app.updateCartData();
        }, 150);
    }

    function getUrl(resource) {
        if (!resource) return '';
        if (typeof resource === 'string') return resource;
        if (resource instanceof URL) return resource.href;
        return resource.url || '';
    }

    function isCartUpdateUrl(url) {
        // Skip the app's own requests (they use ?app=salepify)
        if (!url || url.indexOf('app=salepify') !== -1) return false;
        return /\/cart\/update(\.js)?(\?|#|$)/.test(url);
    }

    function hasDiscountInBody(body) {
        if (!body) return false;
        try {
            if (typeof body === 'string') {
                try {
                    var json = JSON.parse(body);
                    return !!json && typeof json === 'object' && 'discount' in json;
                } catch (e) {
                    return new URLSearchParams(body).has('discount');
                }
            }
            if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('discount');
            if (body instanceof URLSearchParams) return body.has('discount');
        } catch (e) {}
        return false;
    }

    function watchFetch() {
        if (typeof window.fetch !== 'function') return;
        var originalFetch = window.fetch;
        window.fetch = function (resource, config) {
            var isDiscountRequest = isCartUpdateUrl(getUrl(resource)) && hasDiscountInBody(config && config.body);
            var response = originalFetch.apply(this, arguments);
            if (isDiscountRequest) {
                response.then(function (res) { if (res && res.ok) scheduleRecheck(); }).catch(function () {});
            }
            return response;
        };
    }

    function watchXhr() {
        if (!window.XMLHttpRequest) return;
        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
            this.__tlFgUrl = getUrl(url);
            return originalOpen.apply(this, arguments);
        };
        XMLHttpRequest.prototype.send = function (body) {
            if (isCartUpdateUrl(this.__tlFgUrl) && hasDiscountInBody(body)) {
                this.addEventListener('load', function () {
                    if (this.status >= 200 && this.status < 300) scheduleRecheck();
                });
            }
            return originalSend.apply(this, arguments);
        };
    }

    watchFetch();
    watchXhr();

    // ---- Discount box in cart drawer and cart page ----
    var DISCOUNT_BOX_CLASS = 'tl-fg-discount-box';
    var DISCOUNT_BOX_TEXTS = {
        en: {
            placeholder: 'Discount code',
            apply: 'Apply',
            empty: 'Please enter a discount code.',
            invalid: 'This discount code is not valid for your cart.',
            alreadyApplied: 'This discount code is already applied.',
            applied: 'Discount code applied.',
            error: 'Something went wrong. Please try again.',
            remove: 'Remove'
        },
        pt: {
            placeholder: 'Código de desconto',
            apply: 'Aplicar',
            empty: 'Digite um código de desconto.',
            invalid: 'Este código de desconto não é válido para o seu carrinho.',
            alreadyApplied: 'Este código de desconto já foi aplicado.',
            applied: 'Código de desconto aplicado.',
            error: 'Algo deu errado. Tente novamente.',
            remove: 'Remover'
        },
        vi: {
            placeholder: 'Mã giảm giá',
            apply: 'Áp dụng',
            empty: 'Vui lòng nhập mã giảm giá.',
            invalid: 'Mã giảm giá không hợp lệ với giỏ hàng của bạn.',
            alreadyApplied: 'Mã giảm giá này đã được áp dụng.',
            applied: 'Đã áp dụng mã giảm giá.',
            error: 'Đã có lỗi xảy ra. Vui lòng thử lại.',
            remove: 'Xoá'
        }
    };

    var boxConfig = Object.assign({
        enabled: true,
        cartDrawer: true,
        cartPage: true,
        // Checkout buttons: the box is inserted right before the first one in each drawer / cart form
        checkoutSelector: 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]',
        // Elements that wrap the cart drawer
        drawerSelector: 'cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, #sidebar-cart, .cart-drawer, .drawer--cart, [data-cart-drawer]',
        // Optional: insert before this element (inside the same drawer / cart form) instead of the checkout button
        insertBefore: null,
        // Optional: custom function to re-render the theme cart after a code is applied / removed
        refreshCart: null,
        texts: {}
    }, config.discountBox || {});

    var locale = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var boxTexts = Object.assign({}, DISCOUNT_BOX_TEXTS.en, DISCOUNT_BOX_TEXTS[locale] || {}, boxConfig.texts);

    var MESSAGE_STORAGE_KEY = 'tl-fg-discount-box-message';
    var MESSAGE_DURATION = 8000;
    var lastCart = null;
    var lastMessage = null; // kept so the message survives the theme re-rendering the drawer / a page reload
    var isApplying = false;

    try {
        lastMessage = JSON.parse(sessionStorage.getItem(MESSAGE_STORAGE_KEY) || 'null');
        sessionStorage.removeItem(MESSAGE_STORAGE_KEY);
    } catch (error) {
        lastMessage = null;
    }

    function getRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    // `app=salepify` makes Free Gift (and this script's watcher) skip these requests
    async function fetchCart() {
        var res = await fetch(getRoot() + 'cart.js?app=salepify', { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('Cannot load cart');
        lastCart = await res.json();
        return lastCart;
    }

    async function setDiscountCodes(codes) {
        var res = await fetch(getRoot() + 'cart/update.js?app=salepify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
        });
        if (!res.ok) throw new Error('Cannot update discount codes');
        lastCart = await res.json();
        return lastCart;
    }

    function isSameCode(a, b) {
        return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
    }

    // Free gift codes are managed by the app, so they are not shown / removable in the box
    function isFreeGiftCode(code) {
        var app = window.tlFreeGiftOffer;
        if (!app || !app.codeMapRuleId) return false;
        return Array.from(app.codeMapRuleId.keys()).some(function (appCode) { return isSameCode(appCode, code); });
    }

    function injectDiscountBoxStyle() {
        if (document.getElementById(DISCOUNT_BOX_CLASS + '-style')) return;
        var style = document.createElement('style');
        style.id = DISCOUNT_BOX_CLASS + '-style';
        style.textContent = [
            // Layout rules use !important: theme styles for input / button (margin, height, line-height...) must not misalign the row
            '.tl-fg-discount-box{display:block!important;width:100%!important;box-sizing:border-box!important;margin:12px 0!important;padding:0!important;font-size:14px;text-align:left}',
            '.tl-fg-discount-box__form{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:stretch!important;gap:8px!important;width:100%!important;margin:0!important;padding:0!important}',
            '.tl-fg-discount-box__input,.tl-fg-discount-box__apply{box-sizing:border-box!important;height:44px!important;min-height:44px!important;max-height:44px!important;margin:0!important;line-height:normal!important;vertical-align:middle!important;-webkit-appearance:none!important;appearance:none!important;box-shadow:none!important;transform:none!important;position:static!important;top:auto!important}',
            '.tl-fg-discount-box__input{flex:1 1 auto!important;width:auto!important;min-width:0!important;max-width:none!important;padding:0 12px!important;border:1px solid var(--tl-fg-db-border,rgba(0,0,0,.25))!important;border-radius:var(--tl-fg-db-radius,4px)!important;background:var(--tl-fg-db-input-bg,#fff)!important;color:var(--tl-fg-db-input-color,#111)!important;font:inherit;font-size:14px!important;text-transform:uppercase;outline-offset:0}',
            '.tl-fg-discount-box__input::placeholder{text-transform:none;opacity:.6}',
            '.tl-fg-discount-box__apply{flex:0 0 auto!important;width:auto!important;min-width:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;padding:0 18px!important;border:0!important;border-radius:var(--tl-fg-db-radius,4px)!important;background:var(--tl-fg-db-btn-bg,#111)!important;color:var(--tl-fg-db-btn-color,#fff)!important;font:inherit;font-size:14px!important;letter-spacing:normal;cursor:pointer;white-space:nowrap!important}',
            '.tl-fg-discount-box__apply[disabled]{opacity:.6;cursor:default}',
            '.tl-fg-discount-box__message{margin:6px 0 0!important;padding:0!important;font-size:13px}',
            '.tl-fg-discount-box__message[hidden]{display:none!important}',
            '.tl-fg-discount-box__message--error{color:var(--tl-fg-db-error,#d72c0d)}',
            '.tl-fg-discount-box__message--success{color:var(--tl-fg-db-success,#108043)}',
            '.tl-fg-discount-box__codes{display:flex!important;flex-wrap:wrap;gap:6px;margin:8px 0 0!important;padding:0!important;list-style:none!important}',
            '.tl-fg-discount-box__codes:empty{display:none!important}',
            '.tl-fg-discount-box__code{display:inline-flex!important;align-items:center;gap:6px;margin:0!important;padding:4px 10px!important;border-radius:999px;background:var(--tl-fg-db-tag-bg,rgba(0,0,0,.06));font-size:13px}',
            '.tl-fg-discount-box__code::before,.tl-fg-discount-box__code::marker{content:none!important}',
            '.tl-fg-discount-box__remove{width:auto!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;background:none!important;color:inherit!important;font-size:16px!important;line-height:1!important;cursor:pointer}'
        ].join('');
        document.head.appendChild(style);
    }

    function showMessage(box, text, type) {
        var message = box.querySelector('.' + DISCOUNT_BOX_CLASS + '__message');
        if (!message) return;
        message.className = DISCOUNT_BOX_CLASS + '__message' + (type ? ' ' + DISCOUNT_BOX_CLASS + '__message--' + type : '');
        message.textContent = text || '';
        message.hidden = !text;
    }

    function showMessageInAllBoxes(text, type) {
        lastMessage = text ? { text: text, type: type, time: Date.now() } : null;
        // Saved so the message is still shown if the page reloads to refresh the cart
        try {
            if (lastMessage) sessionStorage.setItem(MESSAGE_STORAGE_KEY, JSON.stringify(lastMessage));
            else sessionStorage.removeItem(MESSAGE_STORAGE_KEY);
        } catch (error) {}
        document.querySelectorAll('.' + DISCOUNT_BOX_CLASS).forEach(function (box) { showMessage(box, text, type); });
    }

    function setLoading(loading) {
        isApplying = loading;
        document.querySelectorAll('.' + DISCOUNT_BOX_CLASS + '__apply, .' + DISCOUNT_BOX_CLASS + '__remove').forEach(function (button) {
            button.disabled = loading;
        });
    }

    function renderAppliedCodes() {
        var codes = ((lastCart && lastCart.discount_codes) || []).filter(function (discount) {
            return discount.applicable && !isFreeGiftCode(discount.code);
        });

        document.querySelectorAll('.' + DISCOUNT_BOX_CLASS + '__codes').forEach(function (list) {
            list.innerHTML = '';
            codes.forEach(function (discount) {
                var item = document.createElement('li');
                item.className = DISCOUNT_BOX_CLASS + '__code';

                var label = document.createElement('span');
                label.textContent = discount.code;

                var remove = document.createElement('button');
                remove.type = 'button';
                remove.className = DISCOUNT_BOX_CLASS + '__remove';
                remove.setAttribute('aria-label', boxTexts.remove + ' ' + discount.code);
                remove.innerHTML = '&times;';
                remove.disabled = isApplying;
                remove.addEventListener('click', function () { removeDiscountCode(discount.code); });

                item.appendChild(label);
                item.appendChild(remove);
                list.appendChild(item);
            });
        });
    }

    // ---- Refresh the cart drawer / cart page without reloading the page ----
    var CART_COUNT_SELECTOR = '#cart-icon-bubble, .cart-count-bubble, .cart-link__bubble, [data-cart-count], [data-header-cart-count], .header__cart-count, .cart-count';
    var CART_GOAL_RERENDER_EVENTS = [
        'TLCustomEvent:CartGoal-getPassedMilestone',
        'TLCustomEvent:CartGoal-handleAutoAddGift',
        'TLCustomEvent:CartGoal-handleAddtoCart',
        'TLCustomEvent:CartGoal-handleApplyOrderDiscount',
        'TLCustomEvent:CartGoal-handleApplyFreeShippingCode'
    ];
    var SUPPRESS_CART_GOAL_RENDER = 'tl-fg-suppress';
    var appRefreshSupported = null;

    // The app's own cart refresh (prevent-reload.script.js) only supports some themes; on the others it reloads the page
    function isAppRefreshSupported() {
        if (appRefreshSupported !== null) return appRefreshSupported;
        if (typeof window.tlGetRefreshCartFunc !== 'function') return false;
        try {
            // Unsupported themes get `() => window.location.reload()`, supported ones an async function that awaits the theme refresh
            appRefreshSupported = /await/.test(String(window.tlGetRefreshCartFunc(function () {})));
        } catch (error) {
            appRefreshSupported = false;
        }
        return appRefreshSupported;
    }

    function getSectionElement(element) {
        return element.closest('[id^="shopify-section-"]');
    }

    // Elements to update: cart drawer(s), the cart page section, cart count bubbles
    function collectCartTargets() {
        var targets = [];

        function addTarget(element, selector) {
            var section = getSectionElement(element);
            if (!section) return;
            var isCovered = targets.some(function (target) { return target.element === element || target.element.contains(element); });
            if (!isCovered) targets.push({ element: element, section: section, selector: selector, isCart: selector !== CART_COUNT_SELECTOR });
        }

        document.querySelectorAll(boxConfig.drawerSelector).forEach(function (drawer) {
            if (drawer.parentElement && drawer.parentElement.closest(boxConfig.drawerSelector)) return;
            addTarget(drawer, boxConfig.drawerSelector);
        });

        if (isCartPage()) {
            document.querySelectorAll(boxConfig.checkoutSelector + ', form[action*="/cart"]').forEach(function (element) {
                if (element.closest(boxConfig.drawerSelector)) return;
                var section = getSectionElement(element);
                if (section) addTarget(section, null);
            });
        }

        document.querySelectorAll(CART_COUNT_SELECTOR).forEach(function (element) {
            if (element.closest(boxConfig.drawerSelector)) return;
            addTarget(element, CART_COUNT_SELECTOR);
        });

        return targets;
    }

    function findNewElement(newSection, target) {
        if (!newSection) return null;
        if (target.element === target.section) return newSection;

        if (target.element.id) {
            var byId = newSection.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(target.element.id) : target.element.id));
            if (byId) return byId;
        }
        var index = Array.prototype.indexOf.call(target.section.querySelectorAll(target.selector), target.element);
        return index === -1 ? null : newSection.querySelectorAll(target.selector)[index] || null;
    }

    // Uses the Section Rendering API: fetch the sections again and replace the content of each target
    // (the target element itself is kept, so an open drawer stays open)
    async function refreshCartSections() {
        var targets = collectCartTargets();
        if (!targets.some(function (target) { return target.isCart; })) return false;

        var sectionIds = [];
        targets.forEach(function (target) {
            var sectionId = target.section.id.replace('shopify-section-', '');
            if (sectionIds.indexOf(sectionId) === -1) sectionIds.push(sectionId);
        });

        var htmlBySection = {};
        // The Section Rendering API returns at most 5 sections per request
        for (var i = 0; i < sectionIds.length; i += 5) {
            var res = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.slice(i, i + 5).join(',')), {
                headers: { Accept: 'application/json' }
            });
            if (!res.ok) return false;
            Object.assign(htmlBySection, await res.json());
        }

        var refreshedCart = false;
        var parser = new DOMParser();
        targets.forEach(function (target) {
            var html = htmlBySection[target.section.id.replace('shopify-section-', '')];
            if (!html) return;
            var doc = parser.parseFromString(html, 'text/html');
            var newSection = doc.getElementById(target.section.id) || doc.body;
            var newElement = findNewElement(newSection, target);
            if (!newElement) return;

            target.element.innerHTML = newElement.innerHTML;
            if (target.isCart) refreshedCart = true;
        });

        if (refreshedCart) rerenderAppWidgets();
        log('cart refreshed without reload', refreshedCart, sectionIds);
        return refreshedCart;
    }

    async function refreshCartUI() {
        try {
            if (typeof boxConfig.refreshCart === 'function') {
                await boxConfig.refreshCart(lastCart);
                rerenderAppWidgets();
                return true;
            }
            return await refreshCartSections();
        } catch (error) {
            console.warn(LOG_PREFIX, 'Error when refreshing the cart', error);
            return false;
        }
    }

    // The widgets the apps put inside the cart are gone after the cart HTML is replaced
    function rerenderAppWidgets() {
        try {
            if (window.tlGiftInCartWidget && typeof window.tlGiftInCartWidget.trackingCartDrawer === 'function') window.tlGiftInCartWidget.trackingCartDrawer();
            if (window.tlCartGoalEmbed && typeof window.tlCartGoalEmbed.renderAllCartGoals === 'function') window.tlCartGoalEmbed.renderAllCartGoals();
        } catch (error) {
            console.warn(LOG_PREFIX, error);
        }
        injectDiscountBoxes();
    }

    // Progress bar (Cart Goal): when `window.TLCustomEventCartGoal == 1` it dispatches events instead of
    // re-rendering the cart itself (a page reload on unsupported themes). The flag is computed on read,
    // because the app's refresh helper loads after this script.
    var merchantCartGoalFlag;
    var hasMerchantCartGoalFlag = 'TLCustomEventCartGoal' in window;
    var suppressCartGoalRender = false;
    var cartGoalFlagInstalled = false;

    function usesCartGoalDiscountInput() {
        // These themes need the progress bar's default (flag not set) behavior to sync their own discount field
        var themeName = (window.Shopify && window.Shopify.theme && window.Shopify.theme.schema_name) || '';
        return /Minimog|Unsen/.test(themeName);
    }

    if (config.preventReload !== false && !hasMerchantCartGoalFlag) {
        try {
            Object.defineProperty(window, 'TLCustomEventCartGoal', {
                configurable: true,
                get: function () {
                    if (hasMerchantCartGoalFlag) return merchantCartGoalFlag;
                    if (suppressCartGoalRender) return SUPPRESS_CART_GOAL_RENDER;
                    // Always handled here: the progress bar's own refresh supports fewer themes than Free Gift's
                    return usesCartGoalDiscountInput() ? undefined : 1;
                },
                set: function (value) {
                    merchantCartGoalFlag = value;
                    hasMerchantCartGoalFlag = true;
                }
            });
            cartGoalFlagInstalled = true;
        } catch (error) {
            console.warn(LOG_PREFIX, error);
        }
    }

    // Refresh the cart the same way Free Gift does: the app's theme refresh when the theme is supported,
    // otherwise the Section Rendering API
    async function refreshCartLikeFreeGift() {
        if (typeof boxConfig.refreshCart === 'function' || !isAppRefreshSupported()) return refreshCartUI();

        try {
            var refresh = window.tlGetRefreshCartFunc(function () {});
            await refresh();
            rerenderAppWidgets();
            return true;
        } catch (error) {
            console.warn(LOG_PREFIX, 'Error when refreshing the cart', error);
            return refreshCartUI();
        }
    }

    // ---- One cart refresh after Free Gift and the progress bar have finished their checks ----
    // Both apps refresh the cart after changing it. Requests are merged and run once nothing is checking anymore.
    var busyCount = 0;
    var refreshState = { pending: false, checkCartGoal: false, needInitialize: false, running: false, timer: null, waiters: [] };

    function trackBusy(promise) {
        busyCount++;
        var done = function () {
            busyCount = Math.max(0, busyCount - 1);
            if (refreshState.pending) scheduleCartRefresh();
        };
        Promise.resolve(promise).then(done, done);
        return promise;
    }

    function requestCartRefresh(options) {
        options = options || {};
        refreshState.pending = true;
        if (options.checkCartGoal) refreshState.checkCartGoal = true;
        if (options.needInitialize) refreshState.needInitialize = true;
        scheduleCartRefresh();
        return new Promise(function (resolve) { refreshState.waiters.push(resolve); });
    }

    function scheduleCartRefresh() {
        clearTimeout(refreshState.timer);
        refreshState.timer = setTimeout(runCartRefresh, 200);
    }

    async function runCartRefresh() {
        // Called again when the running checks are done
        if (!refreshState.pending || refreshState.running || busyCount > 0) return;

        // Free Gift changed the cart: the progress bar checks its milestones first, its refresh request is merged into this one
        if (refreshState.checkCartGoal) {
            refreshState.checkCartGoal = false;
            patchCartGoal();
            var cartGoalToCheck = window.tlCartGoalEmbed;
            if (cartGoalToCheck && typeof cartGoalToCheck.updateCartTotal === 'function') {
                cartGoalToCheck.updateCartTotal();
                return scheduleCartRefresh();
            }
        }

        var needInitialize = refreshState.needInitialize;
        var waiters = refreshState.waiters;
        refreshState.pending = false;
        refreshState.needInitialize = false;
        refreshState.waiters = [];
        refreshState.running = true;

        try {
            var isRefreshed = await refreshCartLikeFreeGift();
            if (!isRefreshed) return window.location.reload();

            var cartGoal = window.tlCartGoalEmbed;
            if (needInitialize && cartGoal && typeof cartGoal.initializeLocalStorage === 'function') cartGoal.initializeLocalStorage();

            // Same as the app's refresh callback: re-render the Free Gift widgets for the refreshed cart
            var app = window.tlFreeGiftOffer;
            if (app && typeof app.updateCartData === 'function') await app.updateCartData();
            log('cart refreshed once (free gift + progress bar)');
        } catch (error) {
            console.warn(LOG_PREFIX, error);
        } finally {
            refreshState.running = false;
            waiters.forEach(function (resolve) { resolve(); });
            if (refreshState.pending) scheduleCartRefresh();
        }
    }

    // Progress bar: mark it busy from `updateCartTotal` until its milestone check is done
    var cartGoalWaiters = [];

    function releaseCartGoalWaiters() {
        var waiters = cartGoalWaiters;
        cartGoalWaiters = [];
        waiters.forEach(function (release) { release(); });
    }

    function patchCartGoal() {
        var cartGoal = window.tlCartGoalEmbed;
        if (!cartGoal || cartGoal.__tlFgPatched) return;
        if (typeof cartGoal.updateCartTotal !== 'function' || typeof cartGoal.getPassedMilestone !== 'function') return;
        cartGoal.__tlFgPatched = true;

        var originalGetPassedMilestone = cartGoal.getPassedMilestone;
        cartGoal.getPassedMilestone = function () {
            var result = originalGetPassedMilestone.apply(this, arguments);
            trackBusy(result);
            Promise.resolve(result).then(releaseCartGoalWaiters, releaseCartGoalWaiters);
            return result;
        };

        var originalUpdateCartTotal = cartGoal.updateCartTotal;
        cartGoal.updateCartTotal = function () {
            var release;
            trackBusy(new Promise(function (resolve) { release = resolve; }));
            cartGoalWaiters.push(release);
            setTimeout(release, 8000);

            // updateCartTotal only works when a cart goal is active, and then renders the widgets right away
            var isActive = false;
            var hadOwnRender = Object.prototype.hasOwnProperty.call(this, 'renderAllCartGoals');
            var originalRender = this.renderAllCartGoals;
            if (typeof originalRender === 'function') {
                this.renderAllCartGoals = function () {
                    isActive = true;
                    return originalRender.apply(this, arguments);
                };
            }
            try {
                return originalUpdateCartTotal.apply(this, arguments);
            } finally {
                if (hadOwnRender) this.renderAllCartGoals = originalRender;
                else delete this.renderAllCartGoals;
                if (!isActive && typeof originalRender === 'function') release();
            }
        };
        log('Progress bar patched');
    }

    // Events sent after the progress bar added products / gifts: it re-initializes its data after the refresh
    var CART_GOAL_INITIALIZE_EVENTS = ['TLCustomEvent:CartGoal-handleAutoAddGift', 'TLCustomEvent:CartGoal-handleAddtoCart'];

    CART_GOAL_RERENDER_EVENTS.forEach(function (eventName) {
        window.addEventListener(eventName, function () {
            if (!cartGoalFlagInstalled || hasMerchantCartGoalFlag) return;
            requestCartRefresh({ needInitialize: CART_GOAL_INITIALIZE_EVENTS.indexOf(eventName) !== -1 });
        });
    });

    // The progress bar script can load before or after this one
    var cartGoalPatchTries = 0;
    (function waitForCartGoal() {
        patchCartGoal();
        if (window.tlCartGoalEmbed && window.tlCartGoalEmbed.__tlFgPatched) return;
        if (++cartGoalPatchTries < 600) setTimeout(waitForCartGoal, 500); // ~5 minutes
    })();

    // Run the Progress bar (Cart Goal) milestone check and wait until it is done.
    // Its rewards (discount codes / gifts) are updated, but its cart re-render (a page reload on
    // unsupported themes) is skipped: the cart is refreshed once afterwards.
    function runCartGoalCheck() {
        var cartGoal = window.tlCartGoalEmbed;
        if (!cartGoal || typeof cartGoal.updateCartTotal !== 'function' || typeof cartGoal.getPassedMilestone !== 'function') {
            return Promise.resolve();
        }

        return new Promise(function (resolve) {
            var originalGetPassedMilestone = cartGoal.getPassedMilestone;
            var hadOwnRender = Object.prototype.hasOwnProperty.call(cartGoal, 'renderAllCartGoals');
            var originalRender = cartGoal.renderAllCartGoals;
            var isActive = false;
            var isDone = false;
            var timer = null;

            function finish() {
                if (isDone) return;
                isDone = true;
                clearTimeout(timer);
                cartGoal.getPassedMilestone = originalGetPassedMilestone;
                resolve();
            }

            cartGoal.getPassedMilestone = function () {
                var result = originalGetPassedMilestone.apply(this, arguments);
                Promise.resolve(result).then(finish, finish);
                return result;
            };

            // updateCartTotal only works when a cart goal is active, and then renders the widgets right away
            if (typeof originalRender === 'function') {
                cartGoal.renderAllCartGoals = function () {
                    isActive = true;
                    return originalRender.apply(this, arguments);
                };
            }

            try {
                cartGoal.updateCartTotal();
            } catch (error) {
                console.warn(LOG_PREFIX, error);
                isActive = false;
            } finally {
                if (hadOwnRender) cartGoal.renderAllCartGoals = originalRender;
                else delete cartGoal.renderAllCartGoals;
            }

            if (!isActive && typeof originalRender === 'function') return finish();
            timer = setTimeout(finish, 10000);
        });
    }

    // Re-check free gift + progress bar conditions with the new discounts, then re-render the theme cart ONCE
    async function refreshAfterDiscountChange() {
        var app = window.tlFreeGiftOffer;
        var useFlagGetter = cartGoalFlagInstalled && !hasMerchantCartGoalFlag;
        var originalCartGoalFlag = useFlagGetter ? null : window.TLCustomEventCartGoal;
        patchCartGoal();

        try {
            // 1. Free gift: add / remove gifts first. The app refreshes the cart after changing gifts
            //    (a page reload on unsupported themes), so that refresh is skipped here and done once below.
            if (app && typeof app.updateCartData === 'function') {
                var originalRefreshCartContent = app.refreshCartContent;
                app.refreshCartContent = function () { return Promise.resolve(); };
                try {
                    await app.updateCartData();
                } catch (error) {
                    console.warn(LOG_PREFIX, error);
                } finally {
                    app.refreshCartContent = originalRefreshCartContent;
                }
            }

            // 2. Progress bar: update its rewards. A truthy value other than 1 makes it skip its own re-render.
            if (useFlagGetter) suppressCartGoalRender = true;
            else window.TLCustomEventCartGoal = SUPPRESS_CART_GOAL_RENDER;
            await runCartGoalCheck();
        } finally {
            if (useFlagGetter) suppressCartGoalRender = false;
            else window.TLCustomEventCartGoal = originalCartGoalFlag;
        }

        // 3. Re-render the cart a single time (without a page reload)
        if (config.preventReload !== false) return requestCartRefresh();
        if (app && typeof app.refreshCartContent === 'function') return app.refreshCartContent();
        window.location.reload();
    }

    async function applyDiscountCode(code) {
        code = String(code || '').trim();
        if (!code) return showMessageInAllBoxes(boxTexts.empty, 'error');
        if (isApplying) return;

        setLoading(true);
        try {
            var cart = await fetchCart();
            var currentCodes = (cart.discount_codes || []).map(function (discount) { return discount.code; });

            var existing = (cart.discount_codes || []).find(function (discount) { return isSameCode(discount.code, code); });
            if (existing && existing.applicable) {
                showMessageInAllBoxes(boxTexts.alreadyApplied, 'error');
                return;
            }

            var newCodes = currentCodes.filter(function (current) { return !isSameCode(current, code); }).concat(code);
            var updatedCart = await setDiscountCodes(newCodes);
            var applied = (updatedCart.discount_codes || []).find(function (discount) { return isSameCode(discount.code, code); });

            if (!applied || !applied.applicable) {
                // Roll back so an invalid code does not stay in the cart
                await setDiscountCodes(currentCodes.filter(function (current) { return !isSameCode(current, code); }));
                showMessageInAllBoxes(boxTexts.invalid, 'error');
                renderAppliedCodes();
                return;
            }

            document.querySelectorAll('.' + DISCOUNT_BOX_CLASS + '__input').forEach(function (input) { input.value = ''; });
            showMessageInAllBoxes(boxTexts.applied, 'success');
            renderAppliedCodes();
            await refreshAfterDiscountChange();
        } catch (error) {
            console.warn(LOG_PREFIX, error);
            showMessageInAllBoxes(boxTexts.error, 'error');
        } finally {
            setLoading(false);
        }
    }

    async function removeDiscountCode(code) {
        if (isApplying) return;

        setLoading(true);
        try {
            var cart = await fetchCart();
            var remainingCodes = (cart.discount_codes || [])
                .map(function (discount) { return discount.code; })
                .filter(function (current) { return !isSameCode(current, code); });

            await setDiscountCodes(remainingCodes);
            showMessageInAllBoxes('', null);
            renderAppliedCodes();
            await refreshAfterDiscountChange();
        } catch (error) {
            console.warn(LOG_PREFIX, error);
            showMessageInAllBoxes(boxTexts.error, 'error');
        } finally {
            setLoading(false);
        }
    }

    function createDiscountBox() {
        var box = document.createElement('div');
        box.className = DISCOUNT_BOX_CLASS;
        box.innerHTML =
            '<div class="' + DISCOUNT_BOX_CLASS + '__form">' +
                '<input type="text" class="' + DISCOUNT_BOX_CLASS + '__input" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
                '<button type="button" class="' + DISCOUNT_BOX_CLASS + '__apply"></button>' +
            '</div>' +
            '<p class="' + DISCOUNT_BOX_CLASS + '__message" role="status" aria-live="polite" hidden></p>' +
            '<ul class="' + DISCOUNT_BOX_CLASS + '__codes"></ul>';

        var input = box.querySelector('.' + DISCOUNT_BOX_CLASS + '__input');
        var button = box.querySelector('.' + DISCOUNT_BOX_CLASS + '__apply');
        input.placeholder = boxTexts.placeholder;
        input.setAttribute('aria-label', boxTexts.placeholder);
        button.textContent = boxTexts.apply;
        button.disabled = isApplying;

        button.addEventListener('click', function () { applyDiscountCode(input.value); });
        // The box can sit inside the cart <form>: Enter must apply the code, not submit the form (go to checkout)
        input.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();
                applyDiscountCode(input.value);
            }
        });

        // Keep the last message briefly when the theme re-renders the drawer
        if (lastMessage && Date.now() - lastMessage.time < MESSAGE_DURATION) showMessage(box, lastMessage.text, lastMessage.type);
        return box;
    }

    function isCartPage() {
        return /\/cart\/?$/.test(window.location.pathname);
    }

    function injectDiscountBoxes() {
        if (!boxConfig.enabled) return;

        var containers = new Set();
        var hasNewBox = false;

        document.querySelectorAll(boxConfig.checkoutSelector).forEach(function (checkoutButton) {
            var drawer = checkoutButton.closest(boxConfig.drawerSelector);
            if (drawer ? !boxConfig.cartDrawer : (!boxConfig.cartPage || !isCartPage())) return;

            var container = drawer || checkoutButton.closest('form') || checkoutButton.parentElement;
            if (!container || containers.has(container)) return;
            containers.add(container);
            if (container.querySelector('.' + DISCOUNT_BOX_CLASS)) return;

            var anchor = (boxConfig.insertBefore && container.querySelector(boxConfig.insertBefore)) || checkoutButton;
            if (!anchor.parentNode) return;
            anchor.parentNode.insertBefore(createDiscountBox(), anchor);
            hasNewBox = true;
        });

        if (!hasNewBox) return;
        if (lastCart) renderAppliedCodes();
        else fetchCart().then(renderAppliedCodes).catch(function () {});
    }

    function initDiscountBox() {
        if (!boxConfig.enabled) return;
        injectDiscountBoxStyle();
        injectDiscountBoxes();

        // Themes re-render the drawer / cart page after every cart change: add the box back when it is gone
        var injectTimer = null;
        new MutationObserver(function () {
            clearTimeout(injectTimer);
            injectTimer = setTimeout(injectDiscountBoxes, 100);
        }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDiscountBox);
    else initDiscountBox();

    var REQUIRED_METHODS = ['getCustomerBuy', 'makeApplyToChecker', 'checkPurchaseType', 'getItems', 'updateCartData'];
    var patchedApp = null;

    function tryPatch(app, isLateLoad) {
        if (!app || patchedApp === app) return;
        if (!app.ajaxApi || typeof app.ajaxApi.cartGet !== 'function') return;

        var missing = REQUIRED_METHODS.filter(function (name) { return typeof app[name] !== 'function'; });
        if (missing.length) {
            console.warn(LOG_PREFIX, 'Free Gift version not supported, missing:', missing.join(', '));
            return;
        }

        patchedApp = app;
        patchFreeGift(app, isLateLoad);
        patchTodayOffer();
    }

    // Debug helper: run `tlFreeGiftDiscountedDebug()` in the browser console
    window.tlFreeGiftDiscountedDebug = function () {
        var app = window.tlFreeGiftOffer;
        console.log(LOG_PREFIX, {
            appLoaded: !!app,
            patched: !!app && patchedApp === app,
            factors: Object.fromEntries(factorByKey),
            revertedLines: Array.from(revertedLines.values()),
            ruleStates: app && app.ruleIdMapState ? Object.fromEntries(app.ruleIdMapState) : null
        });
    };

    if (window.tlFreeGiftOffer) {
        tryPatch(window.tlFreeGiftOffer, true);
    } else {
        // Patch right when the app creates its instance (works with lazy-loaded / delayed app scripts)
        var instance;
        try {
            Object.defineProperty(window, 'tlFreeGiftOffer', {
                configurable: true,
                enumerable: true,
                get: function () { return instance; },
                set: function (value) {
                    instance = value;
                    try {
                        tryPatch(value, false);
                    } catch (error) {
                        console.warn(LOG_PREFIX, error);
                    }
                }
            });
        } catch (error) {
            console.warn(LOG_PREFIX, error);
        }
    }

    // Fallback if the instance is set in a way the setter does not catch
    var tries = 0;
    (function waitForFreeGift() {
        if (patchedApp && patchedApp === window.tlFreeGiftOffer) return;
        if (window.tlFreeGiftOffer) return tryPatch(window.tlFreeGiftOffer, true);
        if (++tries < 600) setTimeout(waitForFreeGift, 500); // ~5 minutes
    })();

    window.addEventListener('salepify:today-offer-ready', patchTodayOffer);
})();